export default __webpack_public_path__ + "static/media/315.6f53766d.gif";